module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/ZoomMinus-793997048a359f44b1d6e4f924ecc9e6.svg";